import { render, staticRenderFns } from "./MessageFillPage.vue?vue&type=template&id=0a871011&"
import script from "./MessageFillPage.vue?vue&type=script&lang=js&"
export * from "./MessageFillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports